import { Dispatch, SetStateAction, useEffect } from 'react';

import { required, useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { ImageUploader } from 'shared/mui/ImageUploader/ImageUploader';
import { TextInput } from 'shared/react-admin/Inputs';
import { MethodLogo } from 'types/embedded/methodLogo';

type MethodLogosEditFormProps = {
  errors: any;
  setIsShowImage?: Dispatch<SetStateAction<boolean>>;
};

export function MethodLogosEditForm({ errors, setIsShowImage }: MethodLogosEditFormProps) {
  const { setError } = useFormContext();
  const record = useRecordContext<MethodLogo>();

  useEffect(() => {
    if (errors) {
      errors?.violations.forEach((error: any) => {
        setError(error?.propertyPath, { type: 'string', message: error.message });
      });
    }
  }, [errors, setError]);

  return (
    <Box py={3}>
      <TextInput
        fullWidth={true}
        helperText={false}
        key="name"
        label="Название"
        resettable
        size="small"
        source="name"
        validate={required()}
        variant="outlined"
      />
      <ImageUploader filePath={record?.filePath} setIsShowImage={setIsShowImage} />
    </Box>
  );
}
